import { InjectionToken } from "@angular/core";

// Outside the generated client, which imports it from here, so app.module can provide it eagerly (PROXY-7).
export const SMART_FORMS_API_BASE_URL = new InjectionToken<string>("SMART_FORMS_API_BASE_URL");
